var map = {
	"./auth/auth-routing.module": [
		"./src/app/auth/auth-routing.module.ts",
		"auth-auth-routing-module"
	],
	"./categories/trail-categories-routing.module": [
		"./src/app/categories/trail-categories-routing.module.ts",
		"default~categories-trail-categories-routing-module~poi-poi-routing-module~stages-stages-routing-modu~cca78080",
		"categories-trail-categories-routing-module"
	],
	"./poi/poi-routing.module": [
		"./src/app/poi/poi-routing.module.ts",
		"default~categories-trail-categories-routing-module~poi-poi-routing-module~stages-stages-routing-modu~cca78080",
		"default~poi-poi-routing-module~stages-stages-routing-module~stamps-stamps-routing-module~trails-trai~c0a59331",
		"default~poi-poi-routing-module~stages-stages-routing-module~stamps-stamps-routing-module",
		"poi-poi-routing-module"
	],
	"./reports/reports-routing.module": [
		"./src/app/reports/reports-routing.module.ts",
		"reports-reports-routing-module"
	],
	"./stages/stages-routing.module": [
		"./src/app/stages/stages-routing.module.ts",
		"default~categories-trail-categories-routing-module~poi-poi-routing-module~stages-stages-routing-modu~cca78080",
		"default~poi-poi-routing-module~stages-stages-routing-module~stamps-stamps-routing-module~trails-trai~c0a59331",
		"default~poi-poi-routing-module~stages-stages-routing-module~stamps-stamps-routing-module",
		"stages-stages-routing-module"
	],
	"./stamps/stamps-routing.module": [
		"./src/app/stamps/stamps-routing.module.ts",
		"default~categories-trail-categories-routing-module~poi-poi-routing-module~stages-stages-routing-modu~cca78080",
		"default~poi-poi-routing-module~stages-stages-routing-module~stamps-stamps-routing-module~trails-trai~c0a59331",
		"default~poi-poi-routing-module~stages-stages-routing-module~stamps-stamps-routing-module",
		"stamps-stamps-routing-module"
	],
	"./trails/trails-routing.module": [
		"./src/app/trails/trails-routing.module.ts",
		"default~categories-trail-categories-routing-module~poi-poi-routing-module~stages-stages-routing-modu~cca78080",
		"default~poi-poi-routing-module~stages-stages-routing-module~stamps-stamps-routing-module~trails-trai~c0a59331",
		"trails-trails-routing-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;